(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestDeleteController',EnvTestDeleteController);

    EnvTestDeleteController.$inject = ['$uibModalInstance', 'entity', 'EnvTest'];

    function EnvTestDeleteController($uibModalInstance, entity, EnvTest) {
        var vm = this;

        vm.envTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EnvTest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
